export const VIEWS = {
  notConnected: 'not_connected',
  hasErrors: 'has_errors'
}
